"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Test__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
        ],
        name: "mul",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
        ],
        name: "mulTruncate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608080604052346015576101b1908161001b8239f35b600080fdfe608080604052600436101561001357600080fd5b60003560e01c90816342cbb15c146100ed575080638f8a618a146100a25763c8a4ac9c1461004057600080fd5b3461009d576040610090670de0b6b3a764000061005c36610106565b61007f8161006b95939561011c565b868152600061007861011c565b5251610152565b61008761011c565b81905293610152565b0482519182526020820152f35b600080fd5b3461009d576040610090670de0b6b3a76400006100be36610106565b826100db826100ce96949661011c565b878152600061007861011c565b6100e361011c565b8190520493610152565b3461009d57600036600319011261009d57602090438152f35b604090600319011261009d576004359060243590565b604051906020820182811067ffffffffffffffff82111761013c57604052565b634e487b7160e01b600052604160045260246000fd5b8181029291811591840414171561016557565b634e487b7160e01b600052601160045260246000fdfea264697066735822122042f832d70143beb433cd21ad894ec63d43859b550b687d2b5e58c61104d1837564736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class Test__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Test__factory = Test__factory;
Test__factory.bytecode = _bytecode;
Test__factory.abi = _abi;
//# sourceMappingURL=Test__factory.js.map